import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import {
  CommonModule,
  isPlatformBrowser,
  ViewportScroller,
} from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ThemeService } from './core/services/common/theme.service';
import { AnalyticsService } from './core/services/common/analytics.service';
import { GoogleAnalyticsInitializerService } from './core/services/common/google-analytics-initializer.service';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { LoggerService } from './core/services/common/logger.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, MainLayoutComponent],
  template: `<app-main-layout></app-main-layout>`,
  styles: [],
})
export class AppComponent implements OnInit {
  title = 'fact-check-trump';
  private isBrowser: boolean;

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private gaInitializer: GoogleAnalyticsInitializerService,
    @Inject(PLATFORM_ID) platformId: Object,
    private viewportScroller: ViewportScroller,
    private logger: LoggerService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    // Skip analytics setup on server
    if (!this.isBrowser) {
      return;
    }

    try {
      // Track app initialization
      this.analyticsService.trackEvent('app_init', {
        timestamp: new Date().toISOString(),
        version: '1.0.0',
      });

      // Also track initial page view
      const initialPath = this.router.url || '/';
      this.analyticsService.trackPageView(initialPath, this.title);

      // Track router navigation events
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          try {
            // Send page view event to Google Analytics using our service
            this.analyticsService.trackPageView(
              event.urlAfterRedirects,
              this.title,
            );

            // Scroll to top on navigation
            this.viewportScroller.scrollToPosition([0, 0]);
          } catch (error) {
            this.logger.error('Error handling navigation event:', error);
          }
        });
    } catch (error) {
      this.logger.error('Error initializing analytics:', error);
    }
  }
}
